import axios from "axios";
import { KEY_TOKEN } from '../utils/constants';
import { API_BASE_URL } from '../config/runtime';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "api-key": "BPjzdOtLUBCm7OyFmtEoLNAp5-txD9RCCJt5iyqOHAMM8Ya9t0BKhSt5agkMq3az508fCnTaetQ3K_Rl7IHNc7U",
  },
});

api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem(KEY_TOKEN);
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
